import { useTranslation } from 'react-i18next';

import { AgentMessageCard } from '../AgentMessageCard/AgentMessageCard';

type AgentActionErrorContentProps = {
  onRetry?: () => void;
};

const AgentActionErrorContent = ({ onRetry }: AgentActionErrorContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 p-3">
      <AgentMessageCard
        description={t('webedi:sidebar.agents.enrichDocuments.error.description')}
        actions={
          onRetry
            ? [
                {
                  label: t('webedi:sidebar.agents.enrichDocuments.error.retryButton'),
                  onClick: onRetry,
                  analyticsId: 'webedi:agent_retry_enrichment',
                },
              ]
            : undefined
        }
      />
    </div>
  );
};

export { AgentActionErrorContent };
